import {Authority} from "../../../admin/components/dictionary/region-education-authorities/dictionary-authority";

export class DicsEnrollCabinet {
  nationalities = [];
  foreign_lang_degrees = [];
  citizenship = [];
  ictype = [];
  icdepartament = [];
  edu_institute_place = [{id: 1, nameRu: 'Город', nameKz: 'Қала', name: ''}, {id: 2, nameRu: 'Село', nameKz: 'Ауыл', name: ''}];
  universities = [];
  universities_professions = [];
  educated = [];
  centerProfessions = [];
  professions = [];
  alternativeCollegeProfessions = [];
  language = [{id: 1, nameRu: 'Русский', nameKz: 'Орысша', name: ''}, {id: 2, nameRu: 'Казахский', nameKz: 'Қазақша', name: ''}, {id: 40, nameRu: 'Уйгурский', nameKz: 'Ұйғыр', name: ''}];
  study_forms = [];
  payment_forms = [];
  study_languages = [];
  benefits = [];
  quotas = [];
  specialExamTypes = [{id: 1, name: 'Предусмотрен допуск'}, {id: 2, name: 'Предусмотрена оценка'}];
  specialExamProvided = [{id: 1, name: 'Допуск'}, {id: 2, name: 'Недопуск'}];
  specialExamBalls = [{id: 2}, {id: 3}, {id: 4}, {id: 5}];
  military_status = [];
  military_office_residence = [];
  orgNames = [];
  mandatorySubjs = [];
  profileSubjs = [];
  mandatoryEntSubjs = [];
  profileEntSubjs = [];
  admissionSubjects = [];
  settingList = {};
  nonRequireDocScans = false;
  requireBenefitsDocScans = false;
  currLang: string = 'ru';
  authority: Authority = null;
  departments = [];
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/dics-enroll-cabinet.ts